module.exports = __webpack_public_path__ + "static/media/lotto90_drawing_bg.10c2fdd6.png";